import { useSessionMetricStore } from "../../hooks/useSessionMetricStore";
import { useCallback, useEffect } from "react";
import { MetricName } from "../../constants/logging";
import { useGetLogger } from "../../hooks/useGetLogger";

const METRIC_PUBLISH_INTERVAL = 60000;

export const useEmitSessionPerformanceMetrics = (): void => {
    const log = useGetLogger();

    const emitMetricsCallback = useCallback(() => {
        const latestSessionMetric = useSessionMetricStore.getState()
            .latestMetric;

        if (!latestSessionMetric) {
            console.debug("No session performance metric");
            return;
        }
        log.publishNumericMetric(
            MetricName.SESSION_FPS,
            latestSessionMetric.fps
        );
        log.publishNumericMetric(
            MetricName.SESSION_LATENCY,
            latestSessionMetric.latency
        );
    }, []);

    useEffect(() => {
        emitMetricsCallback(); // Emit the first metric immediately.
        const intervalId = setInterval(() => {
            emitMetricsCallback();
        }, METRIC_PUBLISH_INTERVAL);

        return () => clearInterval(intervalId);
    }, []);
};
